export default __webpack_public_path__ + "static/media/top1.96663f61.jpg";